module.exports = __webpack_public_path__ + "img/banner_01.9acd29d8.png";